import { LessonReflectionsInsertInput } from 'types/generated/client';
import { UpdateCoachLessonReflectionsMutationVariables } from 'types/generated/server';

export interface PostCoachReflectionOnPlayerLessonPayload extends LessonReflectionsInsertInput {
  reflectOnAllParticipants: boolean;
}

export const COACH_REFLECTION_ON_PLAYER_LESSON_API = `v1/lessons/reflection/on-player`;

export interface PutCoachReflectionOnPlayerLessonPayload
  extends UpdateCoachLessonReflectionsMutationVariables {
  reflectOnAllParticipants: boolean;
  lessonId: string;
  coachUserId: string;
}

export const UPDATE_COACH_REFLECTION_ON_PLAYER_LESSON_API = `v1/lessons/reflection/on-player/update`;
